export const {getMetadata} = {
    getMetadata: `/api/v1/misc/metadata`,
};
